import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";

// Firebase
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import db from "../../firebase/firebase";

const FindRooms = () => {
  const navigate = useNavigate();
  const [publicRooms, setPublicRooms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, "rooms"),
      where("isPrivate", "==", false),
      orderBy("createdAt", "desc"),
      limit(20)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const rooms = [];
      snapshot.forEach((doc) => {
        const roomData = doc.data();

        // Count active users (users with heartbeat in last 15 seconds)
        const activeUsers = roomData.activeUsers || {};
        const now = new Date();
        const activeCount = Object.values(activeUsers).filter((lastSeen) => {
          if (!lastSeen) return false;
          const lastSeenDate = lastSeen.toDate ? lastSeen.toDate() : new Date(lastSeen);
          const diffSeconds = (now - lastSeenDate) / 1000;
          return diffSeconds < 15; // Consider active if seen in last 15 seconds
        }).length;

        // Only add rooms with at least 1 active user
        if (activeCount > 0) {
          rooms.push({
            id: doc.id,
            ...roomData,
            activeUserCount: activeCount,
          });
        }
      });
      setPublicRooms(rooms);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const joinRoom = (roomId) => {
    navigate(`/${roomId}`);
  };

  return (
    <div className="find-rooms-container">
      <h3 className="find-rooms-title">Public Rooms</h3>
      {isLoading ? (
        <p>Loading...</p>
      ) : publicRooms.length === 0 ? (
        <p className="no-rooms">No public rooms available</p>
      ) : (
        <ul className="rooms-list">
          {publicRooms.map((room) => (
            <li
              key={room.id}
              className="room-item"
              onClick={() => joinRoom(room.id)}
            >
              <span className="room-name">{room.roomName} </span>
              <span className="room-users">({room.activeUserCount || 0} active)</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FindRooms;
